module.exports = __webpack_public_path__ + "394daec92b5ba4953f5328ff45e8dec1.svg";